import React from 'react'
import injectSheet from 'react-jss'
import styles from './content-holder.styles'
import classNames from 'classnames'

const ContentHolder = ({ classes, children, className }) => (
  <div className={classNames(classes.container, className)}>{children}</div>
)

export default injectSheet(styles)(ContentHolder)
